import dayjs from 'dayjs';
import type { Dayjs } from 'dayjs';

import { Locale } from '../enums/Locale';
import { useLocalization } from '../providers/LocaleProvider';
import { localizeDate } from '../utils/date';
import { getDayJsLocale } from '../utils/dayjs-locale';

interface UseLocalisedDateRangeOptions {
  minDate: string;
  maxDate: string;
}

const GERMAN_LOCALES = [Locale.De_De_H24, Locale.De_At, Locale.De_Ch];
const DUTCH_LOCALES = [Locale.Nl_Be, Locale.Nl_Nl];
const SHORT_DASH = '\u2011';
const LONG_DASH = '\u2013';

const useLocalisedMonthWithDay = (date: string) => {
  const { locale } = useLocalization();
  const daySuffix = GERMAN_LOCALES.includes(locale) ? '.' : '';
  const dayJsLocale = getDayJsLocale(locale);
  const dateInstance = dayjs(date).locale(dayJsLocale);
  const dayOfMonth = `${dateInstance.format('D')}${daySuffix}`;
  const month = dateInstance.format('MMM');

  return `${dayOfMonth} ${month}`;
};

export const useLocalisedDateRange = ({ minDate, maxDate }: UseLocalisedDateRangeOptions) => {
  const { locale } = useLocalization();
  const localisedDateMin = useLocalisedMonthWithDay(minDate);
  const localisedDateMax = useLocalisedMonthWithDay(maxDate);
  const separator = DUTCH_LOCALES.includes(locale) ? SHORT_DASH : LONG_DASH;

  return `${localisedDateMin} ${separator} ${localisedDateMax}`;
};

export const useLocalizedDate = (date: string | Dayjs) => {
  const { locale } = useLocalization();

  return localizeDate(date, locale);
};
